import { render, staticRenderFns } from "./SecretariaVirtualnew.vue?vue&type=template&id=1fb352e5&scoped=true"
import script from "./SecretariaVirtualnew.vue?vue&type=script&lang=js"
export * from "./SecretariaVirtualnew.vue?vue&type=script&lang=js"
import style0 from "./SecretariaVirtualnew.vue?vue&type=style&index=0&id=1fb352e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb352e5",
  null
  
)

export default component.exports